import { Tooltip } from 'antd'

import type { ProcedureItem } from 'features/Procedure/state/procedure-api.type'

import styles from './columns.module.scss'

export const productsTableColumns = (onProductClick?: (product: ProcedureItem) => void) => [
  {
    title: 'Product',
    dataIndex: 'code_text',
    key: 'code_text',
    render: (codeText: string, record: ProcedureItem) => (
      <span className='customLink' onClick={() => onProductClick?.(record)}>
        {codeText}
      </span>
    ),
    sorter: {
      compare: (a: ProcedureItem, b: ProcedureItem) => {
        return a.code_text.localeCompare(b.code_text)
      },
      multiple: 1,
    },
  },
  {
    title: 'ICD',
    dataIndex: 'justify_codes',
    key: 'justify_codes',
    render: (codes: string[]) => {
      if (!codes || codes.length === 0) return null
      const codesString = codes.join(', ')
      return (
        <Tooltip title={codesString}>
          <div className={styles.justifyCodes}>{codesString}</div>
        </Tooltip>
      )
    },
  },
  {
    title: 'Qty',
    dataIndex: 'units',
    key: 'units',
    render: (units: number) => units.toString(),
    sorter: {
      compare: (a: ProcedureItem, b: ProcedureItem) => {
        return a.units - b.units
      },
      multiple: 3,
    },
  },
  {
    title: 'Price',
    dataIndex: 'fee',
    key: 'fee',
    render: (fee: number) => `$${fee.toFixed(2)}`,
    sorter: {
      compare: (a: ProcedureItem, b: ProcedureItem) => {
        return a.fee - b.fee
      },
      multiple: 4,
    },
  },
  {
    title: 'Discount',
    dataIndex: 'discount_amount',
    key: 'discount_amount',
    render: (discountAmount: number | undefined, record: ProcedureItem) => {
      if (!discountAmount) return '-'
      const label = record.discount_name ? `${record.discount_name}: ` : ''
      return `${label}$${discountAmount.toFixed(2)}`
    },
    sorter: {
      compare: (a: ProcedureItem, b: ProcedureItem) => {
        return (a.discount_amount ?? 0) - (b.discount_amount ?? 0)
      },
      multiple: 5,
    },
  },
  {
    title: 'Total',
    dataIndex: 'total_price',
    key: 'total_price',
    render: (_totalPrice: number | undefined, record: ProcedureItem) => {
      const total =
        typeof record.total_price === 'number' ? record.total_price : record.units * record.fee
      return `$${total.toFixed(2)}`
    },
    sorter: {
      compare: (a: ProcedureItem, b: ProcedureItem) => {
        const totalA = typeof a.total_price === 'number' ? a.total_price : a.units * a.fee
        const totalB = typeof b.total_price === 'number' ? b.total_price : b.units * b.fee
        return totalA - totalB
      },
      multiple: 6,
    },
  },
]
